import React from 'react'
import { Link } from 'react-router-dom'
// import '@fortawesome/fontawesome-free/css/all.min.css';

function Services() {
  return (
    <div>
      <div
        className="services-style-three-area default-padding bottom-less bg-gray-secondary bg-cover"
        style={{ backgroundImage: "url(static/img/shape/24.png)" }}
      >
        <div className="container" style={{ backgroundImage: "/" }}>
          <div className="row">
            <div className="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
              <div className="site-heading text-center">
                <h4 className="sub-title">Our Services</h4>
                <h2 className="title split-text">
                  Everything You Need to Grow Online
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container" >
          <div className="row">
            {/* Single Item */}
            <div className="col-xl-4 col-lg-6 col-md-6 mb-30" >
              <div className="services-style-three-item wow fadeInUp" style={{
                backgroundImage: "url(/static/img/icon/performance-marketing.png)",

                backgroundSize: "cover",           
                backgroundRepeat: "no-repeat",     
                backgroundPosition: "center",      

              }}>
                <div className="item-title">
                  {/* <img title='Microcode Software' src="static/img/icon/Performance marketing (png)-01-01.png" alt="Img Not Found" /> */}
                  <div style={{ width: "100%", height: "20vh" }}></div>
                  <h4 className="text-white">
                    <Link to="/performance-marketing" className="text-white">Performance Marketing</Link>
                  </h4>
                  <p className="text-white">
                    Our focus is on using data to conduct campaigns that optimize ROI and maximize growth in measurable quantities.
                  </p>
                  <div className="d-flex mt-30">
                    <Link to="/performance-marketing">
                      <i style={{
                        display: "inline-block",
                        fontStyle: "normal",
                        fontWeight: "900"
                      }} className="fas fa-long-arrow-right" />
                    </Link>
                    <div className="service-tags">
                      <a href='javascript:void(0)' className="text-white">Custom </a>
                      <a href='javascript:void(0)' className="text-white">Software</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End Single Item */}
            {/* Single Item */}
            <div className="col-xl-4 col-lg-6 col-md-6 mb-30"  style={{
    position: "relative",
    overflow: "hidden",
  }}>
              <div
                className="services-style-three-item wow fadeInUp"
                data-wow-delay="200ms"
                style={{
                backgroundImage: "url(/static/img/icon/a1.png)",

                backgroundSize: "cover",           
                backgroundRepeat: "no-repeat",     
                backgroundPosition: "center",      

              }}
              >
                <div className="item-title">
                  {/* <img title='Microcode Software' src="static/img/icon/Social Media Marketing-01.png" alt="Img Not Found" /> */}
                  <div style={{ width: "100%", height: "20vh" }}></div>
                  <h4>
                    <Link to="/social-media-marketing" className="text-white">Social Media Marketing</Link>
                  </h4>
                  <p className="text-white">
                    We grow your brand and engage your audience using strategic social media.
                    From content to conversions, we make every post count.
                  </p>
                  <div className="d-flex mt-30">
                    <Link to="/social-media-marketing">
                      {/* <i className="fas fa-long-arrow-right" /> */}
                      <i style={{
                        display: "inline-block",
                        fontStyle: "normal",
                        fontWeight: "900"
                      }}
                        className="fa-solid fa-arrow-right"></i>

                    </Link>
                    <div className="service-tags">
                      <a href='javascript:void(0)' className="text-white">Hybrid </a>
                      <a href='javascript:void(0)'className="text-white">Native</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End Single Item */}
            {/* Single Item */}
            <div className="col-xl-4 col-lg-6 col-md-6 mb-30">
              <div
                className="services-style-three-item wow fadeInUp"
                data-wow-delay="400ms"
                style={{
                backgroundImage: "url(/static/img/icon/website-development.png)",
                backgroundSize: "cover",           
                backgroundRepeat: "no-repeat",     
                backgroundPosition: "center",      

              }}
              >
                <div className="item-title">
                  {/* <img title='Microcode Software' src="static/img/icon/Website Development_Mesa de trabajo 1.png" alt="Img Not Found" /> */}
                  <div style={{ width: "100%", height: "20vh" }}></div>
                  <h4>
                    <Link to="/website-development" className="text-white">Website Development</Link>
                  </h4>
                  <p className="text-white">
                    We design rapid, secure, and scalable websites to help your business grow long term.
                    Built for performance, crafted for impact.
                  </p>
                  <div className="d-flex mt-30">
                    <Link to="/website-development">
                      <i style={{
                        display: "inline-block",
                        fontStyle: "normal",
                        fontWeight: "900"
                      }} className="fas fa-long-arrow-right" />
                    </Link>
                    <div className="service-tags">
                      <a href='javascript:void(0)' className="text-white">UI & UX </a>
                      <a href='javascript:void(0)' className="text-white">Web</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End Single Item */}
          </div>
        </div>
      </div>

    </div>
  )
}

export default Services
